import React, { useEffect, useRef, useState } from 'react';

const DEFAULT_REVEAL_MS = 3000;

function EyeIcon({ open }) {
  if (open) {
    return (
      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.8}
          d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228L3 3m13.512 13.512L21 21m-4.26-4.26a6 6 0 01-8.49-8.49"
        />
      </svg>
    );
  }
  return (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
}

/**
 * Password field with an eye toggle that briefly reveals the value.
 */
export function PasswordInput({
  className = '',
  revealMs = DEFAULT_REVEAL_MS,
  disabled = false,
  ...inputProps
}) {
  const [visible, setVisible] = useState(false);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, []);

  const toggleReveal = () => {
    if (disabled) return;
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    if (visible) {
      setVisible(false);
      return;
    }
    setVisible(true);
    hideTimerRef.current = setTimeout(() => {
      setVisible(false);
      hideTimerRef.current = null;
    }, revealMs);
  };

  const mergedClassName = `${className} pr-12`.trim();

  return (
    <div className="relative">
      <input
        {...inputProps}
        type={visible ? 'text' : 'password'}
        disabled={disabled}
        className={mergedClassName}
      />
      <button
        type="button"
        onClick={toggleReveal}
        disabled={disabled}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-white disabled:opacity-50"
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : `Show password for ${Math.round(revealMs / 1000)} seconds`}
      >
        <EyeIcon open={visible} />
      </button>
    </div>
  );
}

export default PasswordInput;
